/**
 * The callback queue: inbound calls nobody has dealt with yet.
 *
 * Its own file rather than a fortieth export from `lib/calls.ts`, which is past
 * seven hundred lines and has already been split once. The dividing line is the
 * one `callSeen.ts` drew next door - that file is what one operator has LOOKED
 * at, this one is what the desk has DONE - and the difference is the whole
 * feature: the bell goes quiet when somebody opens the folder, and this number
 * only moves when somebody rings back.
 */
import { api } from "./api";

/** How many inbound calls are still waiting. Desk-wide, not per operator. */
export function getCallbackCount(): Promise<{ count: number }> {
  return api.get("/admin/crm/calls/callbacks");
}

export interface HandledResult {
  call: { id: string; handledAt: string | null; handledBy: string | null };
  /** The queue's fresh size, so the rail's number moves on the same round trip
   *  that moved the row rather than a request later. */
  count: number;
}

/** Tick a missed call off, or put it back. Refused with 409 on a call the queue
 *  would never show, so the button cannot report success and change nothing. */
export function setCallHandled(id: string, handled: boolean): Promise<HandledResult> {
  return api.post(`/admin/crm/calls/${encodeURIComponent(id)}/handled`, { handled });
}
